// Centralized color palette — single source of truth for all UI colors.
// Import from here instead of hardcoding hex values in components.
// When the board look changes, update colors here and everything propagates.

// ─── Rarity colors ─────────────────────────────────────────────
// Used in: Board, LetterShop, AlphabetPanel, StoryPanel, MasteryCard, tailwind config
export const RARITY = {
  Common: '#6b7f8a',
  Uncommon: '#2d8a4e',
  Rare: '#3b7dd8',
  Legend: '#9b59b6',
} as const

export type Rarity = keyof typeof RARITY

// ─── ForgeMetrics gauge colors ─────────────────────────────────
export const GAUGE = {
  inkPositive: '#4a7cbb',
  inkNegative: '#3b7dd8',
  pressPositive: '#d4a054',
  pressNegative: '#7a8fa0',
} as const

// ─── TypefaceTree branch colors ────────────────────────────────
export const TYPEFACE = {
  serif: '#4a7cbb',
  mono: '#3b7dd8',
  bold: '#d4a054',
  italic: '#9b59b6',
} as const

// ─── Misc hardcoded accents ────────────────────────────────────
export const UI = {
  /** Board empty-slot hover border */
  slotHover: '#3b6a9e',
  /** AlphabetPanel unowned cell border */
  cellBorder: '#d4dbe4',
  /** AlphabetPanel unowned cell text */
  cellMuted: '#7a8fa0',
  /** AlphabetPanel owned cell background tint */
  cellOwnedBg: 'rgba(74,124,187,0.06)',
  /** TypefaceTree empty tier bar */
  tierEmpty: '#d4dbe4',
  /** StoryPanel fallback rarity */
  storyFallback: '#6b7f8a',
} as const
